import { LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { effect } from "@preact/signals-core";
import { productData, selectedVariantId } from "../store/product-store";
import { setProductCutoff, isHolidayShippingEnabled } from "../store/holiday-store";

@customElement("product-provider")
export class ProductProvider extends LitElement {
  @property({ type: String, attribute: "data-id" }) dataId = "";
  @property({ type: String, attribute: "data-collections-id" }) collectionsId = "";
  @property({ type: String, attribute: "data-product-cutoff" }) productCutoff = "";

  private _productDataLoaded = false;

  connectedCallback() {
    super.connectedCallback();
    const scriptTag = document.getElementById(this.dataId);

    if (scriptTag) {
      const data = JSON.parse(scriptTag.textContent || "{}");

      // Load collections if provided
      if (this.collectionsId) {
        const collectionsTag = document.getElementById(this.collectionsId);
        if (collectionsTag) {
          const collections = JSON.parse(collectionsTag.textContent || "[]");
          data.collections = collections;
        }
      }

      // Inject inventory quantities into variants (like card-provider does)
      const quantitiesId = this.dataId.replace("ProductJson", "ProductVariantQuantities");
      const qtyEl = document.getElementById(quantitiesId);
      if (qtyEl?.textContent) {
        const qtys = qtyEl.textContent
          .split("/")
          .filter(Boolean)
          .map((s: string) => parseInt(s.trim(), 10));
        data.variants.forEach((v: any, i: number) => {
          v.inventory_quantity = isNaN(qtys[i]) ? 0 : qtys[i];
        });
        console.log("[product-provider] Injected inventory quantities:", qtys);
      } else {
        console.warn("[product-provider] No inventory quantities found");
      }

      // Add product-level cutoff date from Liquid metafield (if exists)
      if (this.productCutoff) {
        if (!data.metafields) data.metafields = {};
        if (!data.metafields.holiday_shipping) data.metafields.holiday_shipping = {};
        data.metafields.holiday_shipping.holiday_shipping_cutoff_date = this.productCutoff;
      }

      productData.value = data;
      this._productDataLoaded = true;

      // Initialize variant ID
      const urlParam = new URLSearchParams(window.location.search).get('variant');
      const urlVariantId = urlParam ? parseInt(urlParam, 10) : NaN;
      const validVariant = !isNaN(urlVariantId) && data.variants.find((v: any) => v.id === urlVariantId);
      selectedVariantId.value = validVariant ? urlVariantId : data.variants[0].id;

      // Try to set cutoff immediately (in case holiday shipping already initialized)
      setProductCutoff(data);
    }
    
    // Watch for holiday shipping to be enabled, then re-calculate cutoff
    effect(() => {
      if (isHolidayShippingEnabled.value && this._productDataLoaded) {
        setProductCutoff(productData.value);
      }
    });
  }

  render() {
    return null;
  } // Invisible
}
